import { ITEM_TYPES } from '../../config/constants';
import { contracts } from '../../config/blockchain';
import Log from '../../utils/Log';
import moment from 'moment';

export const FETCH_SALE_ITEMS = 'FETCH_SALE_ITEMS';

export const fetchSaleItems = () => async (dispatch, getState) =>
  contracts.stickItemTypeSale.getSales((error, sales) => {
    if (!error) {
      Log.info(`Sales count: ${sales.length}.`);

      Promise.all(sales.map(sale => {
        return new Promise((resolve, reject) => {
          contracts.stickItemTypeSale.getSaleInfo(sale, (error, saleInfo) => {
            if (saleInfo) {
              const startTime = saleInfo[3].toNumber();
              const endTime = saleInfo[4].toNumber();
              const timeNow = moment().unix();
              const timeRemaining = endTime - timeNow;

              if (timeRemaining > 0 && startTime < timeNow) { // Filter expired and sales not started yet
                const uri = saleInfo[0];

                window.fetch(uri).then((response) => {
                  response.json().then((schema) => {
                    resolve({
                      type: ITEM_TYPES.SALE,
                      id: sale.toNumber(),
                      uri: uri,
                      price: saleInfo[1].toNumber(),
                      remainingItems: saleInfo[2].toNumber(),
                      startTime: startTime,
                      endTime: endTime,
                      schema: schema
                    });
                  }).catch((error) => {
                    Log.error(`Failed when trying to parse JSON. ${error}.`);
                    resolve(false); // Always resolve - Promise.all is all or nothing
                  });
                }).catch((error) => {
                  Log.error(`Failed when trying to fetch JSON. ${error}.`);
                  resolve(false);
                });
              } else {
                resolve(false);
              }
            } else {
              resolve(false);
            }
          });
        });
      })).then(saleItems => {
        dispatch({
          type: FETCH_SALE_ITEMS,
          payload: saleItems.filter(Boolean) // Remove resolve(false) from array
        });
      });
    } else {
      Log.error(`Failed when tried to get SaleItems ${error}.`);
    }
  });



// WEBPACK FOOTER //
// ./src/redux/actions/saleItemsActions.js